import React, { useState } from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Textarea } from '../../../../legacy-design-system/form-text'
import { AttackEventNoteHistoryItemHeader } from './attack-event-discussion-note-header'
import { AttackEventNoteHistoryItemProps } from './attack-event-discussion'
import { MutationUpdateAttackEventNote } from './actions/update-attack-event-note-mutation'

const cssAttackEventDiscussionEntry = css`
  width: 100%;
  border: 1px solid ${theme.color.neutral30};
  border-radius: 3px;
`

// NOTE: Body active/inactive padding text is hardcoded to ensure alignment of text when switching modes
const cssBodyInActiveText = css`
  padding: 16px;
  cursor: pointer;
`

function AttackEventNoteHistoryItemBodyEditing({
  organizationId,
  attackEventUuid,
  attackEventNote,
  currentNote,
  draftNote,
  stopEditing,
  updateEditing
}: {
  draftNote: string
  currentNote: string
  stopEditing: () => void
  updateEditing: (any) => void
} & AttackEventNoteHistoryItemProps) {
  return (
    <MutationUpdateAttackEventNote>
      {(updateNote) => {
        return (
          <Textarea
            data-testid="attack-event-discussion-note-textarea"
            onBlur={() => {
              stopEditing()
              if (currentNote.trim() !== draftNote.trim()) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                updateNote({
                  variables: {
                    organizationId,
                    attackEventUuid,
                    attackEventNoteUuid: attackEventNote.uuid,
                    note: draftNote
                  }
                })
              }
            }}
            value={draftNote}
            rows={3}
            expand={true}
            resize="vertical"
            onChange={updateEditing}
            autoFocus={true}
            classNameFormTextPrimaryContainer={css`
              padding: 9px 5px 9px 5px;
            `}
          />
        )
      }}
    </MutationUpdateAttackEventNote>
  )
}

function AttackEventNoteHistoryItemBody(
  props: AttackEventNoteHistoryItemProps
) {
  const [editing, setEditing] = useState(false)
  const [draftNote, updateDraftNote] = useState(props.attackEventNote.note)

  const startEditing = () => setEditing(true)
  const stopEditing = () => setEditing(false)
  const updateEditing = (e) => updateDraftNote(e)

  // eslint-disable-next-line unicorn/prefer-ternary
  if (editing) {
    return (
      <AttackEventNoteHistoryItemBodyEditing
        updateEditing={updateEditing}
        stopEditing={stopEditing}
        currentNote={props.attackEventNote.note}
        draftNote={draftNote}
        {...props}
      />
    )
  } else {
    return (
      <p className={cssBodyInActiveText} onClick={startEditing}>
        {draftNote}
      </p>
    )
  }
}

export function AttackEventNoteHistoryItem(
  props: AttackEventNoteHistoryItemProps
) {
  return (
    <div className={cssAttackEventDiscussionEntry}>
      <AttackEventNoteHistoryItemHeader {...props} />
      <AttackEventNoteHistoryItemBody {...props} />
    </div>
  )
}
